import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import store from '../../../store';
import LocalStorage from '../../../components/DeviceStorage/LocalStorage';
import Utils from '../../../utils/Utils';

class MultiContentSearch extends AbstractRequestTask {
    constructor(groupIds = '') {
        super();
        this.group_ids = groupIds.groupIds;
        const user = store.getState().user;
        this.user_token = user && user.user_token ? user.user_token : false;
        this.format_types = groupIds.formatTypes;
    }

    getEncType() {
        return 'multipart/form-data';
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        let _url = `${http}${url}/services/payway/paymentservice/multicontentsearch?`;
        _url += Utils.buildQueryParams(this.getGETParams());
        return _url;
    }

    getMethod() {
        return 'POST';
    }

    getParams() {
        const params = {};
         params.extra_params = this.format_types;// JSON.stringify({"group_ids":{"833500":{"format_types":"susc"},"922082":{"format_types":"susc"}}}) // JSON.stringify({group_ids: this.group_ids});
         if(this.user_token)
            params.token = this.user_token || null;

        return params;
    }

    getShowErrorModal() {
        return false;
    }

    getGETParams() {
        return super.getParams();
    }

    getRetriesNumber() {
        return 0;
    }

    success(data, b) {
        this.resolve(data);
    }

    isValid(data) {
        if(data.errors || !data.data) {
            return false;
        }
        return true;
    }

    getHeaders() {
        return {}
    }

}

export default MultiContentSearch;



// WEBPACK FOOTER //
// ./src/requests/tasks/search/MultiContentSearchTask.js